import {
    FETCH_INOVICE_MONTHS_REQUEST,
    FETCH_INOVICE_MONTHS_SUCCESS,
    FETCH_INOVICE_MONTHS_FAILED,
    FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST,
    FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS,
    FETCH_INVOICE_ANNUAL_SUMMARY_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED,
    FETCH_SELECTED_YEAR
} from './mutation-type'

const mutations = {
    [FETCH_INOVICE_MONTHS_REQUEST]: state => {
        state.status.months = 'loading'
    },
    [FETCH_INOVICE_MONTHS_SUCCESS]: (state, { status, data }) => {
        state.status.months = status
        if (status === 204) {
            state.months = []
            state.summary = []
        } else {
            state.months = data
        }
    },
    [FETCH_INOVICE_MONTHS_FAILED]: (state, error) => {
        state.status.months = 'error'
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST]: state => {
        state.status.summary = 'loading'
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS]: (state, { status, data }) => {
        state.status.summary = status
        if (status === 204) {
            state.summary = []
        } else {
            state.summary = data
        }
    },
    [FETCH_INVOICE_ANNUAL_SUMMARY_FAILED]: (state, error) => {
        state.status.summary = 'error'
    },
    [DOWNLOAD_INVOICE_PDF_REQUEST]: state => {
        state.status.pdfDownload = 'loading'
    },
    [DOWNLOAD_INVOICE_PDF_SUCCESS]: (state, data) => {
        state.status.pdfDownload = 'success'
    },
    [DOWNLOAD_INVOICE_PDF_FAILED]: (state, error) => {
        state.status.pdfDownload = 'error'
    },
    [FETCH_SELECTED_YEAR]: (state, data) => {
        state.selectedYear = data
    }
}

export default mutations
